"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = require("@/utils/index");
var _admin = require("@/store/modules/admin");
var _points = require("@/api/points");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.list = [];
    this.startDate = '';
    this.endDate = '';
    this.loggedInUser = null;
    this.listQuery = {
      page: 1,
      limit: 10,
      enabled: true,
      sort: 'id,DESC',
      filter: {
        enabled: '$eq'
      }
    };
  }
  created() {
    this.loggedInUser = _admin.AdminModule;
    this.fetchData();
  }
  async fetchData() {
    const response = await (0, _points.getMonthlyWinners)((0, _index.getQuery)(this.listQuery));
    this.list = response;
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: ''
})], default_1.prototype, "dateRange", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'MonthlyLeaderboardTable',
  components: {}
})], default_1);
var _default = exports.default = default_1;